import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M9.502 4.385c-2.696 0-4.87 2.06-4.87 4.615s2.174 4.615 4.87 4.615 4.87-2.06 4.87-4.615c0-2.554-2.174-4.615-4.87-4.615m0 7.615c-1.742 0-3.166-1.345-3.166-3s1.42-3 3.166-3 3.166 1.345 3.166 3-1.424 3-3.166 3m6.206-7.804c0 .599-.51 1.077-1.136 1.077-.632 0-1.136-.482-1.136-1.077 0-.594.508-1.076 1.136-1.076s1.136.482 1.136 1.076m3.225 1.093c-.072-1.442-.42-2.72-1.534-3.772C16.289.465 14.94.136 13.419.063 11.85-.02 7.149-.02 5.58.063c-1.517.069-2.865.398-3.98 1.45S.143 3.843.067 5.285c-.09 1.486-.09 5.94 0 7.426.072 1.442.42 2.72 1.534 3.772s2.459 1.381 3.98 1.454c1.569.084 6.27.084 7.838 0 1.521-.069 2.87-.398 3.98-1.454 1.11-1.053 1.458-2.33 1.534-3.772.09-1.486.09-5.936 0-7.422m-2.026 9.017c-.33.787-.97 1.394-1.806 1.71-1.25.47-4.217.362-5.599.362s-4.353.105-5.6-.361a3.13 3.13 0 0 1-1.805-1.711C1.601 13.12 1.716 10.309 1.716 9s-.11-4.125.381-5.306c.33-.787.97-1.394 1.806-1.71 1.25-.47 4.217-.362 5.6-.362 1.38 0 4.352-.105 5.599.361.83.313 1.47.92 1.805 1.711.496 1.185.382 3.997.382 5.306s.114 4.125-.382 5.306"
    }, null, -1)
  ])))
}
export default { render: render }